import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';
import { formatDateBr } from '@core/utils/filter';
import SLSTipoComunicadoService from '@/services/Cadastros/Comunicado/SLSTipoComunicado.service';
// Notification
import { useToast } from 'vue-toastification/composition';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default function useUsersList(nameModule) {
  // Use toast
  const toast = useToast();
  const sLSTipoComunicadoService = new SLSTipoComunicadoService();
  const refTipoComunicadoListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: 'tipocomunicadoid', label: 'Código', sortable: false },
    { key: 'tipocomunicadodescricao', label: 'Descrição', sortable: true },
    { key: 'actions', label: 'Ações', sortable: false },
  ];
  const perPage = ref(10);
  const totalTipoComunicado = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref('');
  const sortBy = ref('tipocomunicadoid');
  const isSortDirDesc = ref(false);
  const overlay = ref(true);
  const statusFilter = ref(null);

  const dataMeta = computed(() => {
    const localItemsCount = refTipoComunicadoListTable.value ? refTipoComunicadoListTable.value.localItems.length : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalTipoComunicado.value,
    };
  });

  const refetchData = () => {
    refTipoComunicadoListTable.value.refresh();
  };

  watch([currentPage, perPage, searchQuery, statusFilter], () => {
    refetchData();
  });

  const fetchTipoComunicado = (ctx, callback) => {
    overlay.value = true;
    sLSTipoComunicadoService.index({
      q: searchQuery.value,
      perPage: perPage.value,
      page: currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      fullObject: true,
    }).then((response) => {
      const { data, total } = response;
      overlay.value = false;
      callback(data);
      perPage.value = response.perPage;
      currentPage.value = response.page;
      totalTipoComunicado.value = total;
    })
      .catch((error) => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching users list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });
      });
  };

  const create = async (body) => {
    try {
      const response = await sLSTipoComunicadoService.store(body);

      if (response || (response.status >= 200 && response.status < 300)) {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Sucesso',
            text: 'Tipo Comunicado cadastrado com sucesso!',
            icon: 'CheckIcon',
            variant: 'success',
          },
        });
        refetchData();
      } else {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Erro',
            text: 'Tipo Comunicado não foi cadastrado.',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });
      }
    } catch (error) {
      toast({
        component: ToastificationContent,
        props: {
          title: 'Erro',
          text: 'Tipo Comunicado não foi cadastrado.',
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      });
    }
  };
  const Updated = async (body) => {
    await sLSTipoComunicadoService.update(body);
    refetchData();
  };

  const removerData = async (id) => {
    await sLSTipoComunicadoService.destroy(id);
    refetchData();
  };

  const resolveTypeFieldText = type => {
    if (type === 'VARCHAR') return 'Texto';
    if (type === 'BOOLEAN') return 'Verdadeiro/Falso';
    if (type === 'DATE') return 'Data';
    if (type === 'DATETIME') return 'Data e Hora';
    if (type === 'DECIMAL') return 'Monetário';
    if (type === 'TEXT') return 'Texto Longo';
    if (type === 'INTEGER' || type === 'INT') return 'Númerico';
    return 'Sem Tipo';
  };
  const resolveTypeFieldIcon = type => {
    if (type === 'VARCHAR') return 'tabler:abc';
    if (type === 'BOOLEAN') return 'Verdadeiro/Falso';
    if (type === 'DATE') return 'system-uicons:calendar-date';
    if (type === 'DATETIME') return 'formkit:datetime';
    if (type === 'TEXT') return 'mdi:text-long';
    if (type === 'DECIMAL') return 'tabler:decimal';
    if (type === 'DECIMAL' || type === 'INTEGER' || type === 'INT') return 'tabler:123';
    return 'nonicons:type-16';
  };

  const resolveItemStatusVariant = (status) => {
    if (status === 'PENDING') return 'light-warning';
    if (status === 'ATIVO') return 'light-success';
    if (status === 'INATIVO') return 'light-danger';
    return 'primary';
  };

  return {
    fetchTipoComunicado,
    tableColumns,
    perPage,
    currentPage,
    totalTipoComunicado,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refTipoComunicadoListTable,
    overlay,
    resolveTypeFieldText,
    resolveTypeFieldIcon,
    resolveItemStatusVariant,
    refetchData,
    create,
    Updated,

    // Extra Filters
    statusFilter,
    removerData,
  };
}
